var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M12.001 3C5.926 3 1.003 6.948 1.003 11.821c0 2.02.855 3.868 2.273 5.357-.64 1.67-1.972 3.087-1.994 3.104-.283.297-.36.73-.198 1.103.164.373.538.615.95.615 2.642 0 4.726-1.09 5.976-1.964 1.242.386 2.582.607 3.991.607C18.076 20.643 23 16.694 23 11.82 23 6.948 18.076 3 12.001 3zm0 15.607a11.31 11.31 0 01-3.368-.513l-.975-.305-.838.585a9.306 9.306 0 01-2.47 1.23c.313-.513.618-1.09.855-1.705l.455-1.192-.885-.924c-.778-.819-1.71-2.172-1.71-3.962 0-3.74 4.009-6.785 8.936-6.785 4.928 0 8.937 3.045 8.937 6.785 0 3.741-4.009 6.786-8.937 6.786z"
  }))));
}

export default SvgComment;